export const createRedsysForm = (redsysData) => {
	const form = document.createElement('form');
	form.method = 'POST';
	form.action = process.env.NEXT_PUBLIC_REDSYS_URL;

	for (const [key, value] of Object.entries(redsysData)) {
		const input = document.createElement('input');
		input.type = 'hidden';
		input.name = key;
		input.value = value;
		form.appendChild(input);
	}

	document.body.appendChild(form);
	return form;
};
